export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', description: '所有最新爆料内容', icon: 'ri-global-line', count: 24 },
  { name: '娱乐圈', slug: 'entertainment', description: '娱乐圈明星八卦与内幕', icon: 'ri-movie-2-line', count: 8 },
  { name: '网红主播', slug: 'influencer', description: '网红主播相关爆料', icon: 'ri-live-line', count: 6 },
  { name: '社会事件', slug: 'society', description: '社会热点事件深度挖掘', icon: 'ri-fire-line', count: 5 },
  { name: '科技圈', slug: 'tech', description: '科技行业内部消息', icon: 'ri-smartphone-line', count: 3 },
  { name: '体育圈', slug: 'sports', description: '体育界内幕与趣闻', icon: 'ri-basketball-line', count: 2 },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜私会神秘女子，酒店共度八小时被拍',
    excerpt: '据知情人士透露，该男星近期事业正值巅峰，多部影视作品待播，此次绯闻或对其商业代言造成重大影响。狗仔队连续蹲守72小时终于拍到关键画面。',
    content: `<p>近日，娱乐圈再曝重磅绯闻。据多位知情人士透露，某位近期风头正劲的顶流男星，在结束某品牌活动后，并未返回住处，而是驱车前往位于朝阳区的一家五星级酒店。</p><p>据蹲守的狗仔团队描述，当晚约11点30分，一位身披黑色风衣、戴着口罩和墨镜的神秘女子低调进入酒店大堂。约20分钟后，该男星乘坐保姆车抵达酒店地下车库，通过VIP通道直接进入酒店房间。</p><p>直到次日早上7点45分，该男星才独自驾车离开酒店。狗仔团队经过多方比对确认，该神秘女子疑似某知名影视公司新晋签约艺人，两人此前曾在某综艺节目中有过合作。</p><p>截至目前，双方团队均未对此事作出回应。业内人士分析，若此绯闻属实，该男星正在洽谈的多个高端品牌代言可能面临变数。据不完全统计，其目前身背约12个商业代言，年商业价值超过2亿元。</p><p>本网将持续关注此事进展。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20soft%20warm%20lighting%2C%20cinematic%20noir%20style%2C%20empty%20hallway%20with%20elegant%20carpet%2C%20subtle%20shadows%2C%20dramatic%20composition%2C%20high%20end%20interior%20design%2C%20editorial%20photography&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '黑料调查组',
    publishDate: '2026-08-07',
    views: 128500,
    comments: 3421,
    tags: ['顶流男星', '绯闻', '酒店', '娱乐圈'],
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '知名带货主播直播间暗箱操作曝光，团队内部聊天记录流出',
    excerpt: '一份据称来自某头部主播团队的内部聊天记录在网络疯传，内容涉及刷单、虚假宣传、恶意打压竞争对手等多项违规操作，引发行业震动。',
    content: `<p>今日凌晨，一份长达47页的聊天记录截图在各大社交平台疯狂传播。该聊天记录据称来自某粉丝量超过5000万的头部带货主播团队内部工作群，时间跨度从2025年3月至2026年7月。</p><p>记录中详细披露了多项违规操作手法：通过第三方机构批量刷单制造虚假销量、在直播中夸大产品功效进行虚假宣传、组织水军在竞争对手直播间恶意刷差评、以及与部分品牌方签订排他性"二选一"协议。</p><p>其中最令人震惊的是，该团队还建立了一套完整的"黑公关"体系，专门用于抹黑不合作品牌和竞争对手主播。记录显示，该团队每月用于"黑公关"的预算高达80万元。</p><p>目前，多个直播平台已表示将对此事展开调查。市场监管部门相关人士向本网透露，若聊天记录内容属实，涉事主播可能面临巨额罚款甚至吊销营业执照的处罚。</p><p>该主播原定今晚的直播已被平台临时取消，其个人账号评论区已被网友攻陷。</p>`,
    category: '网红主播',
    categorySlug: 'influencer',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20multiple%20computer%20screens%20showing%20chat%20messages%2C%20dramatic%20red%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20cyberpunk%20aesthetic%2C%20cluttered%20desk%20with%20papers%2C%20investigative%20journalism%20style%2C%20cinematic%20noir&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '黑料调查组',
    publishDate: '2026-08-06',
    views: 95600,
    comments: 2876,
    tags: ['直播带货', '刷单', '聊天记录', '网红主播'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '某省会城市副市长被曝拥有多套海外房产，纪委已介入调查',
    excerpt: '网络爆料称，某省会城市副市长及其家属在海外持有至少5套房产，总价值超过3000万美元。该官员此前曾多次在公开场合强调"廉洁从政"。',
    content: `<p>昨日晚间，一份详细列出某省会城市副市长海外资产的文件在网络上引发轩然大波。根据爆料信息，该官员通过亲属代持等方式，在美国、加拿大、澳大利亚共持有5套豪宅，购买时间集中在2020年至2025年间。</p><p>文件显示，这些房产分别位于洛杉矶比弗利山庄、温哥华西区、悉尼达令港等顶级地段。其中最贵的一处位于比弗利山庄，购入价为1250万美元，目前市值已超过1800万美元。</p><p>值得注意的是，该官员2025年申报的个人年收入约为45万元人民币，而其子女均在海外就读昂贵的私立学校，学费每年超过8万美元。收入与支出的巨大反差引发了公众对其财产来源的强烈质疑。</p><p>今天上午，该省纪委监委通过官方微博发布消息称，已关注到网络反映的相关问题，正在按程序进行核查。如发现违纪违法问题，将依规依纪依法严肃处理。</p><p>本网记者尝试联系该官员本人，其办公室工作人员表示"不便回应"。</p>`,
    category: '社会事件',
    categorySlug: 'society',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20exterior%20at%20twilight%2C%20modern%20architecture%20with%20large%20windows%2C%20palm%20trees%2C%20Beverly%20Hills%20style%2C%20dramatic%20sky%2C%20investigative%20mood%2C%20cinematic%20lighting%2C%20warm%20golden%20hour%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '深度调查部',
    publishDate: '2026-08-06',
    views: 85600,
    comments: 4521,
    tags: ['反腐', '海外房产', '纪委', '社会事件'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '某手机品牌暗中收集用户隐私数据，技术分析报告独家披露',
    excerpt: '安全研究人员发现，某国产主流手机品牌在系统中预置了多款隐蔽的数据采集模块，可在用户不知情的情况下上传通讯录、位置、通话记录等敏感信息。',
    content: `<p>今日，国内知名安全研究机构"数字盾牌"发布了一份长达120页的技术分析报告，揭露某国产手机品牌在其定制安卓系统中内置了多个隐秘的数据采集模块。</p><p>报告指出，这些模块以系统服务的形式运行，普通用户无法卸载或禁用。采集的数据包括：通讯录完整信息、GPS精确定位（每5分钟上传一次）、通话记录、短信内容、已安装应用列表、WiFi连接历史等。</p><p>更令人担忧的是，部分数据在传输过程中未进行加密处理，存在被第三方截获的风险。研究人员还发现，即使手机处于"关闭位置服务"状态，定位模块仍然在后台持续工作。</p><p>该手机品牌目前在国内市场份额排名前三，累计激活设备超过3亿台。如果报告内容属实，这将是近年来规模最大的消费电子隐私泄露事件之一。</p><p>截至目前，该品牌尚未对此事作出正式回应，但其官方网站的客服页面已涌入大量要求解释的用户留言。</p>`,
    category: '科技圈',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20surveillance%20concept%2C%20smartphone%20with%20glowing%20data%20streams%2C%20dark%20background%20with%20red%20digital%20circuits%2C%20futuristic%20cyber%20aesthetic%2C%20privacy%20breach%20symbolism%2C%20cinematic%20tech%20noir&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '科技调查组',
    publishDate: '2026-08-05',
    views: 72300,
    comments: 2156,
    tags: ['手机', '隐私', '数据安全', '科技圈'],
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    title: '知名女星被爆婚内出轨，与已婚导演同游日本亲密照流出',
    excerpt: '一组疑似某知名女演员与某已婚导演在日本箱根温泉旅馆的亲密照片被曝光。该女演员此前一直以"幸福婚姻"形象示人，此次事件或将彻底颠覆其公众形象。',
    content: `<p>昨日深夜，一组拍摄于日本箱根某高级温泉旅馆的照片在社交平台被匿名账号发布。照片中，一对男女在温泉池边举止亲密，经网友多方比对，女方疑似为近期热播剧女主角、已婚女演员周某，男方则被指认为某已婚知名导演。</p><p>据爆料者称，这组照片拍摄于今年7月中旬。二人以"采风考察"为名，在日本逗留了5天。行程包括箱根温泉、京都岚山、东京银座等热门旅游地，全程入住豪华酒店，消费极为奢靡。</p><p>该女演员的丈夫是圈外人士，两人育有一子，此前多次在社交媒体上秀恩爱，被粉丝称为"娱乐圈模范夫妻"。涉事导演的妻子也是圈内知名制片人，二人结婚超过15年。</p><p>目前，该女演员的社交账号已关闭评论功能，其经纪公司电话一直处于占线状态。多位圈内人士私下表示，此事若属实，将对该女演员正在拍摄的两部大制作影视剧产生直接影响。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20hot%20spring%20ryokan%20at%20dusk%2C%20steam%20rising%20from%20outdoor%20onsen%2C%20traditional%20wooden%20architecture%2C%20misty%20mountain%20background%2C%20romantic%20but%20melancholic%20atmosphere%2C%20soft%20warm%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '娱乐调查组',
    publishDate: '2026-08-05',
    views: 156200,
    comments: 6723,
    tags: ['女星', '出轨', '导演', '日本', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    title: '某千万粉丝网红偷税漏税细节曝光，补缴税款及罚款超千万',
    excerpt: '税务机关公布了一起网红偷逃税案件。某拥有超过3000万粉丝的短视频网红通过设立多家空壳公司、签订阴阳合同等方式，累计偷逃税款超过800万元。',
    content: `<p>今天上午，国家税务总局联合地方税务局召开新闻发布会，通报了一起涉案金额巨大的网络主播偷逃税案件。被通报的网红在短视频平台拥有超过3000万粉丝，年直播带货GMV超过50亿元。</p><p>根据税务部门调查，该网红在2023年至2025年间，通过其亲属和团队成员注册了12家空壳公司，将个人直播收入转化为企业收入，利用小微企业税收优惠政策大幅降低应缴税额。同时还存在通过签订阴阳合同隐匿真实收入的行为。</p><p>经查实，该网红三年间实际收入约为2.3亿元，但申报收入仅为3800万元，累计偷逃个人所得税及增值税共计约860万元。按照相关法规，除补缴税款外，还需缴纳滞纳金及罚款，总金额预计超过1500万元。</p><p>税务部门表示，网络直播行业并非税收"法外之地"，将持续加大对网络主播等高收入群体的税收监管力度。目前已有多位头部网红被列入重点稽查名单。</p>`,
    category: '网红主播',
    categorySlug: 'influencer',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20financial%20documents%20spread%20on%20desk%2C%20calculator%20and%20tax%20forms%2C%20dramatic%20lighting%20from%20window%2C%20tense%20business%20atmosphere%2C%20dark%20wood%20desk%2C%20cinematic%20style%2C%20warm%20professional%20tones&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '财经调查组',
    publishDate: '2026-08-04',
    views: 89200,
    comments: 3210,
    tags: ['偷税漏税', '网红', '税务', '罚款'],
    isHot: false,
    isNew: false,
  },
  {
    id: '7',
    title: '某知名运动员涉嫌操纵比赛结果，国际体育组织启动调查',
    excerpt: '国际体育仲裁机构收到匿名举报材料，指控某中国籍世界冠军级运动员在过去3年间参与操纵了至少6场比赛结果，涉及金额高达数百万元。',
    content: `<p>据可靠消息源透露，国际体育仲裁机构（CAS）已收到一份详细的匿名举报材料，指控某中国籍世界冠军级运动员涉嫌操纵比赛结果。举报材料包含银行转账记录、通讯记录以及多名证人的证词。</p><p>材料显示，该运动员在2024年至2026年间，通过中间人与境外赌博集团勾结，在至少6场重要国际赛事中人为控制比赛进程和结果。每场操纵费用在50万至150万元不等，总涉案金额估计超过600万元。</p><p>举报材料中最具说服力的证据是一段该运动员与中间人的通话录音，录音中可以清晰听到双方讨论"让分"和"控场"的具体细节。技术鉴定已确认录音的真实性。</p><p>该运动员目前在世界排名中位列前三，是中国代表团在下一届奥运会上的夺金热门人选。若指控成立，其职业生涯可能就此终结，中国体育界也将遭遇近年来最大的信誉危机。</p><p>国家体育总局相关人士向本网表示，将积极配合国际组织的调查工作，对违规行为零容忍。</p>`,
    category: '体育圈',
    categorySlug: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20sports%20stadium%20at%20night%2C%20single%20spotlight%20on%20field%2C%20dramatic%20shadows%2C%20tense%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20professional%20sports%20venue%2C%20dark%20and%20moody%20composition&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '体育调查组',
    publishDate: '2026-08-04',
    views: 67500,
    comments: 2891,
    tags: ['体育', '操纵比赛', '运动员', '调查'],
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    title: '某国际奢侈品大牌代工厂黑幕：成本不到售价的5%',
    excerpt: '暗访记者潜入某国际知名奢侈品牌位于东莞的代工厂，揭露了令人震惊的生产内幕：一款售价2万元的包包，实际生产成本不超过1000元。',
    content: `<p>经过长达三个月的卧底调查，本网记者成功潜入某国际顶级奢侈品牌位于东莞的代工厂，揭开了奢侈品行业暴利的冰山一角。</p><p>该工厂为全球多个知名奢侈品牌代工生产皮具产品。在工厂内部，记者亲眼目睹了一款专柜售价高达19800元的手提包，其全部物料成本（包括进口小牛皮、五金件、内衬、拉链等）仅为420元，加上人工和物流成本，总生产成本不超过900元。</p><p>更令人震惊的是，该工厂同时为三个不同"品牌"生产外观几乎完全一致的产品——一个是售价近2万的奢侈品牌，一个是售价约5000元的轻奢品牌，还有一个是售价仅800元的国内电商品牌。三者的用料和工艺差异极小，区别主要在于五金件上的LOGO刻印。</p><p>工厂内部人士透露："奢侈品的定价体系中，品牌溢价通常占到了售价的85%以上。消费者花2万块买的不是产品本身，而是那个LOGO带来的身份认同感。"</p><p>该奢侈品牌中国区公关部对此回应称"不便评论供应链细节"，强调品牌价值体现在"设计、文化和传承"。</p>`,
    category: '社会事件',
    categorySlug: 'society',
    coverImage: 'https://readdy.ai/api/search-image?query=Inside%20luxury%20handbag%20factory%20workshop%2C%20workers%20crafting%20leather%20bags%2C%20industrial%20sewing%20machines%2C%20rolls%20of%20fine%20leather%2C%20dim%20industrial%20lighting%2C%20documentary%20photography%20style%2C%20authentic%20manufacturing%20scene&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '暗访调查组',
    publishDate: '2026-08-03',
    views: 103400,
    comments: 5120,
    tags: ['奢侈品', '代工厂', '暴利', '暗访', '社会事件'],
    isHot: true,
    isNew: false,
  },
  {
    id: '9',
    title: '某AI初创公司数据造假，夸大模型性能骗取融资数亿',
    excerpt: '一家估值超过30亿的国内AI大模型公司被前员工举报：在产品演示和测试报告中系统性地篡改数据，实际模型能力远低于对外宣称的水平。',
    content: `<p>AI行业再曝丑闻。今日，一封来自某头部AI大模型公司前技术骨干的实名举报信在科技圈引发地震。举报信详细披露了该公司在产品测试、融资路演以及媒体报道中系统性地造假行为。</p><p>根据举报内容，该公司在参与行业基准测试（Benchmark）时，通过预先在测试集中混入训练数据、人工干预模型输出结果等手段，使得测试分数虚高30%-50%。在面向投资人的产品演示中，更是直接使用了"伪AI"——看似是AI在回答问题，实则是幕后团队在手动操作。</p><p>借助这些造假手段，该公司在过去18个月内成功完成了三轮融资，累计融资额超过4.5亿元人民币，估值飙升至32亿元。多家知名投资机构，包括两家国资背景的基金均被蒙在鼓里。</p><p>举报人表示："公司内部有一个专门的'演示团队'，他们的日常工作就是编写虚假的测试报告和准备可控的演示环境。真正做技术研发的团队其实只有不到15人，在公司总人数中占比不到10%。"</p><p>该公司的多家投资方已紧急召开会议，要求公司管理层对举报内容做出解释。</p>`,
    category: '科技圈',
    categorySlug: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20data%20center%20with%20server%20racks%2C%20glowing%20blue%20and%20red%20lights%2C%20digital%20data%20streams%2C%20dramatic%20cyberpunk%20aesthetic%2C%20rows%20of%20blinking%20servers%2C%20tense%20technological%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '科技调查组',
    publishDate: '2026-08-03',
    views: 54800,
    comments: 1876,
    tags: ['AI', '造假', '融资', '科技圈'],
    isHot: false,
    isNew: false,
  },
  {
    id: '10',
    title: '选秀节目幕后黑幕：导师打分被操控，晋级名单提前内定',
    excerpt: '多位参与过某大型选秀节目的工作人员联合爆料，节目中的导师打分和观众投票均存在严重造假，最终晋级名单在节目开播前就已确定。',
    content: `<p>随着某大型音乐选秀节目总决赛的落幕，一场关于节目公平性的讨论在网络上持续发酵。今日，6名曾在该节目组工作过的幕后人员通过本网联合发声，揭露了节目中存在的种种黑幕。</p><p>据爆料者称，所谓的"导师打分"实际上是由节目组事先编写的剧本。每位导师的打分表和点评台词都由编剧团队提前准备好，导师只需照着念即可。观众最为关注的"全民投票"环节更是一场彻底的骗局——投票通道实际上只是一个展示界面，后台数据完全由技术团队手动设置。</p><p>"夺冠热门人选A实际上在节目录制第一期之前就已经被确定为冠军。"一位不愿透露姓名的前节目编导表示，"每一位选手的'人设'和'故事线'都是提前设计好的，谁在第几轮被淘汰，谁会'逆袭'，全部写在策划案里。"</p><p>爆料还指出，赞助商对晋级名单拥有最终决定权。某知名饮料品牌作为冠名赞助商，曾明确要求必须让品牌代言人进入前三名，否则将撤回赞助。</p><p>该节目制作方今日下午发布声明，称上述指控"纯属捏造"，将追究爆料者的法律责任。</p>`,
    category: '娱乐圈',
    categorySlug: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20colorful%20stage%20lights%2C%20empty%20judges%20panel%20chairs%2C%20dramatic%20spotlight%2C%20reality%20show%20set%20design%2C%20behind%20the%20scenes%20atmosphere%2C%20contrasting%20bright%20stage%20and%20dark%20backstage%2C%20cinematic%20lighting&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '娱乐调查组',
    publishDate: '2026-08-02',
    views: 113700,
    comments: 4890,
    tags: ['选秀', '黑幕', '造假', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    title: '某电竞战队内部不和实锤，队长被爆私吞奖金、排挤队友',
    excerpt: '某知名电竞战队在无缘世界赛后爆发严重内讧，多名队员公开发声指责队长私吞比赛奖金、故意在训练赛中消极表现、还联合管理层打压新人。',
    content: `<p>在刚刚结束的国际电竞大赛（IEM）中，中国区头号种子战队以0比3的惨淡战绩首轮出局，令无数粉丝心碎。然而，真正让人震惊的是赛后爆发的队内大戏。</p><p>战队ADC选手和辅助选手几乎同时在社交媒体发文，矛头直指队长。ADC选手在长文中透露，2025年战队获得的共计约800万元赛事奖金中，队长以"管理费用"和"经纪人抽成"等名义私吞了超过300万元，分到一线队员手中的不足三分之一。</p><p>辅助选手则爆出更多内幕：队长在日常训练中经常无故缺席、在训练赛中故意选冷门英雄消极比赛、还联合俱乐部管理层将两名有潜力的新人青训选手无故下放，原因仅仅是"担心被取代"。</p><p>更令人唏嘘的是，该队长去年还被媒体评选为"年度最佳电竞队长"，在粉丝心中一直是"暖男人设"。得知真相后，大量粉丝在社交平台发起了"退粉"活动，该队长的个人超话一夜之间掉粉超过60万。</p><p>俱乐部官方目前尚未发布正式声明，但据内部人士透露，战队管理层已召开紧急会议讨论善后方案。</p>`,
    category: '体育圈',
    categorySlug: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20after%20event%2C%20empty%20gaming%20chairs%20with%20dark%20ambient%20lighting%2C%20RGB%20lights%20reflecting%20on%20floor%2C%20dramatic%20atmosphere%2C%20competitive%20gaming%20venue%2C%20cinematic%20wide%20shot&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '电竞调查组',
    publishDate: '2026-08-02',
    views: 78400,
    comments: 3567,
    tags: ['电竞', '内讧', '奖金', '体育圈'],
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '某餐饮连锁品牌被曝使用过期食材，后厨卫生状况触目惊心',
    excerpt: '本网记者卧底某全国连锁网红餐饮品牌后厨一个月，发现其存在系统性使用过期食材、回收剩菜重新上桌、后厨蟑螂老鼠乱窜等严重食品安全问题。',
    content: `<p>食品安全问题再敲警钟。经过一个月的卧底调查，本网记者在号称"国民食堂"的某连锁餐饮品牌后厨，拍摄到了令人作呕的画面。</p><p>该品牌在全国拥有超过2000家门店，年营业额超过60亿元，以"新鲜现炒"和"干净卫生"为卖点吸引消费者。然而在实际操作中，记者发现以下严重问题：</p><p>一、过期食材照用不误。冷库中存储的冷冻肉类，保质期标签被反复修改，有些食材的实际存放时间超过标签标注日期6个月以上。后厨主管直言："只要没发臭，就能用，多加点调料盖住味就行。"</p><p>二、剩菜回收成常态。顾客吃剩的米饭和菜品，被后厨收集后重新加热，混入新做的菜品中继续上桌。高峰期时，一份"招牌红烧肉"中可能有40%是回收肉。</p><p>三、卫生状况极度恶劣。后厨地面油污厚重，蟑螂在调料罐间爬行，老鼠粪便在面粉袋中屡见不鲜。记者在岗一个月，从未见过任何消毒操作。</p><p>报道发布后，该品牌股价盘中暴跌12%，多地市场监管部门已宣布将对其进行突击检查。</p>`,
    category: '社会事件',
    categorySlug: 'society',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dirty%20restaurant%20kitchen%20interior%2C%20greasy%20stainless%20steel%20surfaces%2C%20dim%20industrial%20lighting%2C%20cluttered%20workspace%2C%20food%20safety%20violation%20scene%2C%20documentary%20investigative%20style%2C%20grimy%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '暗访调查组',
    publishDate: '2026-08-01',
    views: 142800,
    comments: 7845,
    tags: ['食品安全', '卧底', '连锁餐饮', '社会事件'],
    isHot: true,
    isNew: false,
  },
];

export const hotArticles = articles.filter(a => a.isHot).slice(0, 5);
export const latestArticles = [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());